import apiCall from "./apiCall";

const ajaxNetwork = {

  async fetchDeviceInfo(device_token){
    const data = {
      device_token: device_token,
    }
    let response = await apiCall("platform/portal/get_device_info", data);
    return response;
  },

  async saveDeviceName(device_token, device_name) {
    const data = {
      device_token: device_token,
      device_name: device_name
    }
    let response = await apiCall("platform/portal/set_nickname", data);
    return response;
  },

  async fetchVoucherInfo(voucher_code){
    const data = {
      voucher_code: voucher_code
    }
    let response = await apiCall("platform/portal/voucher_info", data);
    return response;
  },

  async disconnectDevices(selectedMacs, voucher_id){
    const data = {
      mac_addresses: selectedMacs,
      voucher_id: voucher_id
    }
    let response = await apiCall("platform/portal/disconnect_device", data);
    return response;
  },
  async searchMac(mac_address){
    const data = {
     "mac_address":mac_address
    }
    let response = await apiCall("platform/webclient/search_mac", data);
    return response;
  }

};

export default ajaxNetwork;